<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-actions>
              <v-text-field
                class="ml-5"
                placeholder="Search Users"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                v-if="!userLimit && canCreateCustomer"
                class="mr-1"
                color="primary"
                @click.prevent="showCreatePanel()"
                outlined
              >
                <v-icon class="pr-2">fa-plus</v-icon>Add Company
              </v-btn>
              <v-btn
                v-else
                class="mr-1"
                disabled
                color="primary"
                @click.prevent="showCreatePanel()"
                outlined
              >
                <v-icon class="pr-2">fa-plus</v-icon>Add Company
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="userLimit">
        <v-col md="12">
          <v-alert type="error"
            >You have reached the maximum number of users for your plan</v-alert
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              :loading="loading"
              :items="users"
            >
              <template v-slot:item.confirmed="{ item }">
                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                <v-icon v-else color="error">fa-times</v-icon>
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :id="item.id"
                      v-on="on"
                      outlined
                      small
                      color="secondary"
                      @click.prevent="showEditPanel(item.id)"
                    >
                      <v-icon small>fa-pencil-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <v-tooltip
                  bottom
                  v-if="
                    item.company.data.expiry_days_left < 30 &&
                    item.company.data.state == 3 &&
                    canCreateCustomer
                  "
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="grey" class="ml-1" outlined small>
                      <v-icon small>fa-trash-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete User</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import partnerAPI from '@/api/partner.js';
import companyAPI from '@/api/company.js';
import LayoutBasic from '@/layouts/PartnerHub';
import EditCompany from '@/components/partner/companies/Edit';
import CreateCompany from '@/components/partner/companies/Create';
export default {
  name: 'Company',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        {
          text: 'Lead First Name',
          value: 'first_name',
          sortable: false,
        },
        {
          text: 'Lead Last Name',
          value: 'last_name',
          sortable: false,
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false,
        },

        {
          text: 'ORGANIZATION NAME',
          value: 'company.data.company_name',
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      email: '',
      password: '',
      id: '',
      fullName: '',
      users: [],
      userdata: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmAccess: 'Are you sure you wish to access this user?',
      confirmDelete: 'Are you sure you wish to delete this user?',
      confirmDeleteForLiveUser:
        "As this customer is within their contract period you cannot delete them from the platform. By pressing 'Continue' it will delete the account at the end of their contract period. ",
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    maxUsers: function () {
      return 500;
    },
    userLimit: function () {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    isPartnerLevel: function () {
      if (this.$store.getters.level == 4) {
        return true;
      } else {
        return false;
      }
    },
    canCreateCustomer: function () {
      if (
        this.$store.getters.level == 4 ||
        this.$store.getters.create_customer_permission == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    canManagerAccessCustomer: function () {
      if (this.$store.getters.level == 5) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.setEventBus();
  },
  watch: {
    options: {
      handler() {
        this.getOwners();
      },
      deep: true,
    },
  },
  methods: {
    getOwners() {
      if (this.$store.getters.level == 2) {
        //this.$store.dispatch("logout").then(() => {
        //localStorage.removeItem('todos');
        //this.$router.push("/login");
        //});
      }

      this.loading = true;
      partnerAPI
        .getOwners(
          this.params,
          this.searchParams,
          this.$store.getters.user.id + '&include=company&demo=yes&is_company=1'
        )
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    getOwnersNew() {
      this.loading = true;
      partnerAPI
        .getOwners(
          this.params,
          this.searchParams,
          this.$store.getters.user.id + '&include=company&demo=yes&is_company=1'
        )
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getOwners();
    },
    loginToOwner(id) {
      this.$snotify.confirm(this.confirmAccess, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processAccessUser(toast, id)
          }          
        ],
      });
    },
    processAccessUser(id) {
      this.loading = true;
      partnerAPI.getOwnersDetail(id).then((resp) => {
        this.userdata = resp.data.data;
        this.email = this.userdata[0].email;
        this.password = this.userdata[0].password;
        this.id = this.userdata[0].id;
        this.autologin();
        this.loading = false;
      });
    },
    autologin: function () {
      this.$store
        .dispatch('autologin', {
          id: this.id,
        })
        .then(() => {
          localStorage.setItem('todos', this.$store.getters.user.id);
          this.getProfile();
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.messages = [];
          let errors = err.response.data.errors;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.errorMessage = errMsg;
            this.$snotify.error(errMsg);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 2:
              //this.$router.push("/admin/courses");
              this.$router.push('/playlists');
              break;
            case 4:
              this.$router.push('/partner/users');
              break;
            default:
              this.$router.push('/');
              break;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        this.params = payload;
        this.getOwners();
      });
      EventBus.$on('USERS_ADDED', (payload) => {
        this.params = payload;
        this.getOwnersNew();
      });
    },
    applySearch() {
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' +
        this.search +
        ';company_name:' +
        this.search;
      this.getOwners();
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditCompany,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showDetailsPanel(id) {
      this.$showPanel({
        component: ViewDetails,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateCompany,
        props: {
          params: this.params,
          id: this.$store.getters.user.id,
        },
        openOn: 'right',
      });
    },
    showUserImportPanel() {
      this.$showPanel({
        component: ImportUser,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    changeStatus(id, user_id) {
      this.$snotify.confirm(this.confirmChangeStatus, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel',  className: 'toast-cancel-button' },
          {
            text: 'Continue',  className: 'toast-continue-button',
            action: (toast) => this.processChangeStatus(toast, id, user_id),
          }          
        ],
      });
    },
    processChangeStatus(toast, id, user_id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      companyAPI.updateCompanyState(id, user_id, 'maunally').then((resp) => {
        this.getOwners();
        this.loading = false;
      });
    },
  },
};
</script>
